export default __webpack_public_path__ + "static/media/screenshot2.f657a220.png";